import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ContentItemPlusHighlight } from "scmp-app/components/content/content-item-render/variants/plus-widget-highlight";
import { PlusWidgetTheme } from "scmp-app/components/plus/plus-widget";
import type { plusWidgetHighlightsQuery$key } from "scmp-app/queries/__generated__/plusWidgetHighlightsQuery.graphql";

import { Container, ContentContainer, MoreOnLink, StyledIconArrow } from "./styles";

type Props = {
  className?: string;
  pageType: "homepage" | "section" | "topic";
  plusWidgetTheme: PlusWidgetTheme;
  reference: plusWidgetHighlightsQuery$key;
};

export const PlusWidgetHighlights: FunctionComponent<Props> = ({
  className,
  pageType,
  plusWidgetTheme = PlusWidgetTheme.DARK,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment plusWidgetHighlightsQuery on Query
      @argumentDefinitions(queueName: { type: "String!" }) {
        highlightQueue: queue(filter: { name: $queueName }) {
          items(first: 2) {
            edges {
              node {
                ... on Content {
                  entityId
                  ...plusWidgetHighlight
                }
              }
            }
          }
        }
      }
    `,
    reference,
  );

  return (
    <Container $plusWidgetTheme={plusWidgetTheme} className={className}>
      <ContentContainer>
        {content.highlightQueue?.items?.edges.map(item => (
          <ContentItemPlusHighlight
            key={item.node.entityId}
            plusWidgetTheme={plusWidgetTheme}
            reference={item.node}
          />
        ))}
      </ContentContainer>
      <MoreOnLink pathname="/plus" query={{ module: "content_discovery", pgtype: pageType }}>
        <span>More on SCMP PLUS</span> <StyledIconArrow />
      </MoreOnLink>
    </Container>
  );
};

PlusWidgetHighlights.displayName = "PlusWidgetHighlights";
